module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAANdJREFUOE9jZMACCmp66xkZGBowpP4zPOhvLVbEpodx1CBICNAtjApq+60Z/v1LQQT8fwNGRkYD9Ij4z8DwheE/wxqY+H9GhhsTW4o7QXx4rBVU9/YzMjIUYItFrGL/GW78/PXXcVp32QsUg0Acog1DMwTDIKIMw2IIVoPwGobDEJwGYTUMjyF4DUIxjIAhBA0CKSiq6S3/8fPvQljs4IpVrJmW6CSApBBsUH7VBHEWxj8c5BhwlvXL0wMNDX/ABhXU9O1nZPjvQI5B///8UpzQUfmAagYBAHe+jxNnW36xAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/newIcon/down.png
// module id = p/PX
// module chunks = 1